<template>
  <div class="page">
    <div v-if="!afterRegistration" class="register">
      <h1>Cadastrar</h1>
      <div class="registerForm">
        <el-form ref="form" :model="user">
          <el-row>
            <el-col>
              <el-form-item label="Username">
                <el-input
                  placeholder="Digite seu username"
                  v-model="user.username"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="Email">
                <el-input
                  type="email"
                  placeholder="Digite um email válido"
                  v-model="user.email"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="Nome">
                <el-input
                  placeholder="Digite seu nome"
                  v-model="user.name"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="Data de Nascimento">
                <br />
                <el-date-picker
                  v-model="user.birthDate"
                  type="date"
                  format="DD/MM/YYYY"
                  autocomplete="off"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="Gênero">
                <br />
                <el-radio v-model="user.gender" label="M">Masculino</el-radio>
                <el-radio v-model="user.gender" label="F">Feminino</el-radio>
                <el-radio v-model="user.gender" label="O">Outros</el-radio>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="Cria uma senha">
                <el-input
                  placeholder="Digite uma senha"
                  v-model="user.password"
                  show-password
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="Confirme a senha">
                <el-input
                  placeholder="Digite a senha novamente"
                  v-model="user.password_confirmation"
                  show-password
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row id="register-button">
            <el-form-item>
              <el-button type="primary" @click="createUser"
                >Cadastrar</el-button
              >
            </el-form-item>
          </el-row>
        </el-form>
      </div>
    </div>

    <div id="creationSuccess" v-else>
      <p>Usuário cadastrado com sucesso!</p>
      <br />
      <p>
        Por favor, para continuar o acesso, clique no link que foi enviado para
        o seu email
      </p>
    </div>
  </div>
</template>
<script>
import { registerUser } from "../../services/registrations";

export default {
  data() {
    return {
      user: {},
      afterRegistration: false,
    };
  },

  methods: {
    async createUser() {
      const response = await registerUser(this.user);
      if (response.status == 201) {
        this.handleAfterRegistration();
      }
    },
    handleAfterRegistration() {
      this.afterRegistration = true;
    },
  },
};
</script>
<style scoped>
.register {
  margin-left: 5%;
  margin-right: 5%;
  width: 90%;
}

#creationSuccess {
  padding-top: 2%;
  padding-bottom: 2%;
  padding-left: 2%;
  padding-right: 2%;
  font-size: 25px;
}

.page {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  background-color: #d3dce6;
  width: 40%;
  margin: auto;
  margin-top: 2%;
  margin-bottom: 2%;
  overflow: overlay;
  position: relative;
  display: flex;
  text-align: center;
}

#register-button {
  float: right;
}
</style>
